import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'chameleon/ui-stack/ui/base/button';
import './SubmitButton.scss';

/**
 * Custom submit button that triggers
 * a SubmitConfirmation Page before
 * allowing student submit their exam.
 *
 * This comes as a result of difficulty
 * customizing Learnosity submit button.
 */
const SubmitButton = (props) => {
  const { onShowModal, app, items, isDummyPlayer } = props;
  const itemKeys = Object.keys(items);
  const [areAllQuestionsAnswered, setAllAreQuestionsAnswered] = useState(
    itemKeys?.every((e) => app.attemptedItems().includes(e)),
  );

  const handleOpenSubmitPopover = (event) => {
    const initiatorElement = event.currentTarget;
    if (isDummyPlayer) {
      onShowModal('DummySubmit');
    } else {
      onShowModal('SubmitConfirmation', { initiatorElement });
    }
  };

  useEffect(() => {
    const updateAreAllQuestionsAnswered = () => {
      const updatedAreAllQuestionsAnswered = itemKeys?.every((e) =>
        app.attemptedItems().includes(e),
      );

      if (updatedAreAllQuestionsAnswered !== areAllQuestionsAnswered) {
        setAllAreQuestionsAnswered(updatedAreAllQuestionsAnswered);
      }
    };

    updateAreAllQuestionsAnswered();

    app.on('item:setAttemptedResponse', updateAreAllQuestionsAnswered);

    return () => {
      app.off('item:setAttemptedResponse', updateAreAllQuestionsAnswered);
    };
  });

  return (
    <Button
      isPrimary={areAllQuestionsAnswered}
      isOutline={!areAllQuestionsAnswered}
      isLink={!areAllQuestionsAnswered}
      aria-label="Submit"
      onClick={handleOpenSubmitPopover}
      className="w-full"
    >
      Submit
    </Button>
  );
};

SubmitButton.displayName = 'SubmitButton';

SubmitButton.propTypes = {
  /**
   * Flag for displaying desktop view or mobile view icon.
   * The submit button icon is different on desktop vs mobile.
   * */
  app: PropTypes.object.isRequired,
  onShowModal: PropTypes.func.isRequired,
};

export default SubmitButton;
